import api from './client';
import { forEach, size } from 'constants/lodash';

export const uploadRouteData = (sectorId, routes) => {
  if (!size(routes)) return Promise.resolve();
  const requests = [];
  forEach(routes, (route, id) => requests.push(api(`/resources/${sectorId}/routes/${id}`, { method: 'PUT', body: route })));
  return Promise.all(requests);
};
export const createRoute = (sectorId, route) => api(`/resources/${sectorId}/routes`, { method: 'POST', body: route });
export const deleteRoute = (sectorId, routeId) => api(`/resources/${sectorId}/routes/${routeId}`, { method: 'DELETE' });
export const setVisibility = (sectorId, routeId, isHidden) => api(`/resources/${sectorId}/routes/${routeId}`, { method: 'PUT', body: { isHidden } });
export const updateRoutes = (sectorId, routes) => Promise.all(Object.entries(routes).map(([id, route]) => api(`/resources/${sectorId}/routes/${id}`, { method: 'PUT', body: route })));
export const getNavigationData = sectorId => api(`/sectors/${sectorId}`).then(({ routes }) => routes);
